<template>
  <div id="tags-view-container" class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :key="tag.path"
        :class="isActive(tag) ? 'active' : ''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        class="tags-view-item"
        @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''"
        @contextmenu.prevent.native="openMenu(tag, $event)"
      >
        {{ tag.title }}
        <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">刷新</li>
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">关闭</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭所有</li>
    </ul>
    <img
      class="close-all c-pointer"
      src="@/assets/icon/icon-fill-20x20fork@2x.png"
      title="关闭所有"
      @click="closeAllTags(selectedTag)"
    />
  </div>
</template>

<script>
import ScrollPane from './ScrollPane';
import path from 'path';

export default {
  components: { ScrollPane },
  data() {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: []
    };
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews;
    }
  },
  watch: {
    $route() {
      this.addTags();
      this.moveToCurrentTag();
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu);
      } else {
        document.body.removeEventListener('click', this.closeMenu);
      }
    }
  },
  mounted() {
    this.initTags();
    this.addTags();
  },
  methods: {
    isActive(route) {
      return route.path === this.$route.path;
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix;
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = [];
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path);
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta }
          });
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path);
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags];
          }
        }
      });
      return tags;
    },
    initTags() {
      // 固定tagView
      const routes = this.$router.options.routes;
      const affixTags = (this.affixTags = this.filterAffixTags(routes));
      for (const tag of affixTags) {
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag);
        }
      }
    },
    async addTags() {
      const { name, fullPath } = this.$route;
      if (name != 'RedirectPage') {
        // FIXME: 动态路由会打开多个tag, 并且动态路由无法被正确的设置和移除keep-alve
        // 这样动态路由就失效了， 不过这里用不到
        const repeatRoute = this.visitedViews.find(route => route.name === name);
        if (repeatRoute && fullPath !== repeatRoute.fullPath) {
          // 如果进入的是不同路由参数的同一个页面, 先删除当前路由, 再重新添加(以避免组件还是处于keep-alive状态,生命周期无法触发)
          await this.$store.dispatch('tagsView/delView', repeatRoute);
          await this.$store.dispatch('tagsView/addView', this.$route);
        } else {
          // FIXME: tagsView刷新失效(需要在路由next前addView)
          this.$store.dispatch('tagsView/addView', this.$route);
        }
      }
      return false;
    },
    async moveToCurrentTag() {
      const tags = this.$refs.tag;
      await this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag);
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route);
            }
            break;
          }
        }
      });
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/delCachedView', view).then(() => {
        const { fullPath } = view;
        this.$nextTick(() => {
          this.$router.replace({
            path: '/redirect' + fullPath
          });
        });
      });
    },
    closeSelectedTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view);
        }
      });
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag);
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag();
      });
    },
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return;
        }
        this.toLastView(visitedViews, view);
      });
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        if (this.$route.fullPath === latestView.fullPath) {
          return;
        }
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === 'Home') {
          // to reload home page
          this.$router.replace({ path: '/redirect' + view.fullPath });
        } else {
          this.$router.push('/');
        }
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105;
      const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
      const offsetWidth = this.$el.offsetWidth; // container width
      const maxLeft = offsetWidth - menuMinWidth; // left boundary
      const left = e.clientX - offsetLeft + 15; // 15: margin right
      const offsetTop = document.querySelector('.tags-view-wrapper').getBoundingClientRect().top; // tagsView到顶部的位置
      if (left > maxLeft) {
        this.left = maxLeft;
      } else {
        this.left = left;
      }

      this.top = e.clientY - offsetTop;
      this.visible = true;
      this.selectedTag = tag;
    },
    closeMenu() {
      this.visible = false;
    },
    handleScroll() {
      this.closeMenu();
    }
  }
};
</script>

<style lang="scss" scoped>
.tags-view-container {
  position: relative;
  height: 48px;
  width: 100%;
  border-radius: 4px;
  background: #f5f5f5;
  .tags-view-wrapper {
    background: #ebeef1;
    ::v-deep .el-scrollbar__wrap {
      margin-bottom: -17px !important;
      margin-right: -17px !important;
      .el-scrollbar__view {
        height: 100%;
      }
    }
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      user-select: none;
      margin-top: 8px;
      height: calc(100% - 16px);
      line-height: 34px;
      color: #1b2329;
      padding-right: 22px;
      padding-left: 22px;
      font-size: 15px;
      border-radius: 4px 4px 0px 0px;
      & + .tags-view-item::after {
        content: '';
        position: absolute;
        background-color: #d4d7da;
        display: inline-block;
        width: 1px;
        height: 20px;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
      &:first-of-type {
        margin-left: 8px;
      }
      &:last-of-type {
        margin-right: 8px;
      }
      &.active {
        background-color: #f5f5f5;
        color: #3dafb1;
        &::after {
          background-color: transparent;
        }
      }
      &.active + .tags-view-item {
        &::after {
          background-color: transparent;
        }
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
  .close-all {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    width: 22px;
    height: 22px;
  }
}
</style>

<style lang="scss">
//reset element css of el-icon-close
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      position: relative;
      color: #babdbe;
      font-size: 26px;
      font-weight: bold;
      width: 20px;
      height: 20px;
      margin-left: 5px;
      margin-right: -6px;
      margin-top: -1px;
      vertical-align: middle;
      border-radius: 50%;
      text-align: center;
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: 100% 50%;
      &:hover {
        color: #3dafb1;
      }
      &:before {
        position: absolute;
        display: inline-block;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0.6);
      }
    }
  }
}
</style>
